import {
    Checkbox,
    Collapse,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Stack,
} from "@mui/material"
import { ReactElement, useState } from "react"
import { Control, Controller } from "react-hook-form"

import GenOrDemandOnlyConditions from "./genOrDemandOnlyConditions"
import { ValidatedCheckBoxFormGroup } from "../../inputs/validated/validatedCheckBox"

interface IGenOrDemandOnlyConditions {
    display: boolean
    control: Control
}

const GenAndDemandConditions = ({
    display,
    control,
}: IGenOrDemandOnlyConditions): ReactElement => {
    // Use state bool for set demandLimits
    const [demandLimits, setDemandLimits] = useState(false)
    const [genLimits, setGenLimits] = useState(false)
    const requiredRule = {
        required: { value: true, message: "Please select at least one option" },
    }

    return (
        <Collapse in={display}>
            <Stack>
                <Controller
                    rules={requiredRule}
                    control={control}
                    defaultValue={[]}
                    name="genAndDemandLimitSelection"
                    render={({ field, fieldState: { error } }) => (
                        <>
                            <FormControl>
                                <ValidatedCheckBoxFormGroup field={field}>
                                    <FormControlLabel
                                        value={genLimits}
                                        control={<Checkbox />}
                                        label="Impose an export limit"
                                        onChange={() =>
                                            setGenLimits(!genLimits)
                                        }
                                    />

                                    <GenOrDemandOnlyConditions
                                        display={genLimits}
                                        control={control}
                                        isGenMode
                                    />

                                    <FormControlLabel
                                        value={demandLimits}
                                        control={<Checkbox />}
                                        label="Impose an import limit"
                                        onChange={() =>
                                            setDemandLimits(!demandLimits)
                                        }
                                    />
                                </ValidatedCheckBoxFormGroup>

                                {!!error && (
                                    <FormHelperText error={!!error}>
                                        {error?.message}
                                    </FormHelperText>
                                )}
                            </FormControl>
                            <GenOrDemandOnlyConditions
                                display={demandLimits}
                                control={control}
                                isGenMode={false}
                            />
                        </>
                    )}
                />
            </Stack>
        </Collapse>
    )
}

export default GenAndDemandConditions
